import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Slide } from '@mui/material'
import React from 'react'
import styles from './CustomDialog.module.css'



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
const CustomDialog = ({ isOpen, onClose, children, title, onCancel, onSubmit, submitBtnName = "Submit", cancelBtnName = "Cancel", disableSubmitBtn = false, hideSubmitBtn = false, hideCancelBtn = false }) => {
    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}

        >
            <DialogTitle sx={{ fontFamily: 'sans-serif', fontWeight: 600 }}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText component={'span'} id="alert-dialog-slide-description">
                    <div className={styles['add_participant_dialog_container']}>
                        {children}
                        <div className={styles['add_participant_form_btns']}>
                            {!hideCancelBtn &&
                                <Button
                                    onClick={onCancel}
                                    color="error"
                                    variant="outlined">{cancelBtnName}</Button>}
                            {!hideSubmitBtn &&
                                <Button
                                    sx={{
                                        background: 'var(--hoverColorBold)',
                                        color: 'black',
                                        borderRadius: 1,
                                        '&:hover': {
                                            background: 'var(--hoverColorBold)',
                                        }
                                    }}
                                    disabled={disableSubmitBtn}
                                    onClick={onSubmit}
                                    data-testid="submit-member-btn"
                                    type="submit"
                                    variant="contained">{submitBtnName}</Button>}
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

export default CustomDialog